import { useContext, useEffect } from "react";

import fetchTranslations from "../services/translations";
import {LanguageEnum} from "../models/enums/language.enum";
import {AppStoreContext} from "../store/app-store.ts";

const useTranslations = (locale?: LanguageEnum) => {
    const { setLocale, setMessages, locale: currentLocale, setIsTranslationsLoading } = useContext(AppStoreContext);

    console.log('useTranslations hook called', {
        requestedLocale: locale,
        currentLocale,
        willFetch: locale && currentLocale !== locale
    });

    useEffect(() => {
        if (locale && currentLocale !== locale) {
            console.log('Fetching translations for locale:', locale);
            setIsTranslationsLoading(true);
            fetchTranslations(locale).then((msg) => {
                console.log('✅ Translations loaded successfully for:', locale, 'Message count:', Object.keys(msg).length);
                setMessages(msg);
                setLocale(locale);
                setIsTranslationsLoading(false);
            }, (error) => {
                console.error('Failed to load translations for:', locale, error);
                setIsTranslationsLoading(false);
            });
        } else {
            console.log('Skipping translation fetch (already loaded or no locale)');
        }
    }, [locale, setLocale, setMessages, currentLocale, setIsTranslationsLoading]);
};

export default useTranslations;
